import { DescribeProperty } from '../../common';

export class BillingPortalSessionCreateResponse {
  @DescribeProperty({
    description: 'The url to stripe billing portal for the customer',
  })
  url: string;
}
